import React from 'react';
import FormInput from "../../../Components/Forms/FormInput";
import {ADVISOR_AUTHORIZED_FOR_OPTIONS, BOOLEAN_OPTIONS, fees_payments, NATIONALITY_OPTIONS} from "../../../constants";
import Text from "../../../Components/Text";
import SecondaryTitle from "../../../Components/SecondaryTitle";
import Checkbox from "../../../Components/Forms/Inputs/Checkbox";
import Error from "../../../Components/Forms/Error";

const Details = (props) => {
    const {
        data = {
            'advisor_manages_account':          0,
            'name':                             '',
            'firm_name':                        '',
            'reference_number':                 '',
            'email':                            '',
            'phone_number':                     '',
            'advisor_authorized_for':           '',
            'contact_telephone_opt_in':         0,
            'contact_email_opt_in':             0,
            'contact_sms_opt_in':               0,
            'contact_post_opt_in':              0,
            'fees_payments':                     '',
            'agrees_tandc':                     0,
            'agrees_tax_residency_change':      0,
            'agrees_akoni_authorization':       0,
        },
        errors      = null,
        onChange    = (field, value) => {},
        disabled    = false
    } = props;

    return (
        <React.Fragment>
            <FormInput
                required={true}
                name={'advisor_manages_account'}
                detailedLabel={'Do you want to allow an advisor / accountant to manage your account?'}
                value={data.advisor_manages_account}
                type={'select'}
                options={BOOLEAN_OPTIONS}
                onChange={(value) => onChange('advisor_manages_account', value)}
                disabled={disabled}
                error={errors}
            />
            {data.advisor_manages_account === '1' && (
                <div className={'row m-0 p-0'}>
                    <div className={'col-12 col-md-6 m-0 p-0 pe-md-2'}>
                        <FormInput
                            required={true}
                            name={'name'}
                            detailedLabel={'Name'}
                            value={data.name}
                            type={'text'}
                            onChange={(value) => onChange('name', value)}
                            disabled={disabled}
                            error={errors}
                        />
                    </div>
                    <div className={'col-12 col-md-6 m-0 p-0 ps-md-2'}>
                        <FormInput
                            required={true}
                            name={'firm_name'}
                            detailedLabel={'Firm Name'}
                            value={data.firm_name}
                            type={'text'}
                            onChange={(value) => onChange('firm_name', value)}
                            disabled={disabled}
                            error={errors}
                        />
                    </div>
                    <div className={'col-12 col-md-6 m-0 p-0 pe-md-2'}>
                        <FormInput
                            required={true}
                            name={'reference_number'}
                            detailedLabel={'Reference Number'}
                            value={data.reference_number}
                            type={'text'}
                            onChange={(value) => onChange('reference_number', value)}
                            disabled={disabled}
                            error={errors}
                        />
                    </div>
                    <div className={'col-12 col-md-6 m-0 p-0 ps-md-2'}>
                        <FormInput
                            required={true}
                            name={'email'}
                            detailedLabel={'Email'}
                            value={data.email}
                            type={'text'}
                            onChange={(value) => onChange('email', value)}
                            disabled={disabled}
                            error={errors}
                        />
                    </div>
                    <div className={'col-12 col-md-6 m-0 p-0 pe-md-2'}>
                        <FormInput
                            required={true}
                            name={'phone_number'}
                            detailedLabel={'Phone Number'}
                            value={data.phone_number}
                            type={'text'}
                            onChange={(value) => onChange('phone_number', value)}
                            disabled={disabled}
                            error={errors}
                        />
                    </div>
                    <div className={'col-12 m-0 p-0'}>
                        <FormInput
                            required={true}
                            name={'advisor_authorized_for'}
                            detailedLabel={'Advisor / accountant is authorized and has mandate for:'}
                            value={data.advisor_authorized_for}
                            type={'select'}
                            options={ADVISOR_AUTHORIZED_FOR_OPTIONS}
                            onChange={(value) => onChange('advisor_authorized_for', value)}
                            disabled={disabled}
                            error={errors}
                        />
                    </div>
                </div>
            )}
            <SecondaryTitle>Use of your Personal Information</SecondaryTitle>
            <Text>Personal information about all individuals that is provided with this application form will be used to process your application and for ongoing account maintenance and administrative purposes. It will be held in accordance with UK data protection law (as updated from time to time) and we will only disclose it to other companies within our group, our lawyers, auditors and external advisors, agents and rating agencies, actual or prospective transferees or assignees of Akoni’s rights (and their advisers) where necessary to carry out our lawful business activities or where required to comply with our legal and regulatory obligations. We may disclose such personal information to third party service providers who we engage from time to time in order to provide the applicable services but we will always ensure that they hold it in accordance with UK data protection law.</Text>
            <Text>Find out more visiting <a href="https://www.akonihub.com/static/privacy" target="_blank">www.akonihub.com/static/privacy</a></Text>
            <Text>We will also use the information you provide to us to update you on our products and services and those of third parties which we think may be of interest to you. Please tick the relevant box(es) if you DO NOT wish to be contacted by us for this purpose.</Text>
            <Text>Please tick the relevant box(es) if you wish to be contacted by us for the purpose above:</Text>
            <div className={'row m-0 p-0'}>
                <div className={'col-6 col-md-3 mb-3'}>
                    <Checkbox
                        name={'contact_telephone_opt_in'}
                        label={('telephone')}
                        checked={data.contact_telephone_opt_in === true || data.contact_telephone_opt_in === 'true' || data.contact_telephone_opt_in === 1 || data.contact_telephone_opt_in === '1'}
                        onChange={(value) => onChange('contact_telephone_opt_in', value === true ? 1 : 0)}
                        disabled={disabled}
                    />
                </div>
                <div className={'col-6 col-md-3 mb-3'}>
                    <Checkbox
                        name={'contact_email_opt_in'}
                        label={('email')}
                        checked={data.contact_email_opt_in === true || data.contact_email_opt_in === 'true' || data.contact_email_opt_in === 1 || data.contact_email_opt_in === '1'}
                        onChange={(value) => onChange('contact_email_opt_in', value === true ? 1 : 0)}
                        disabled={disabled}
                    />
                </div>
                <div className={'col-6 col-md-3'}>
                    <Checkbox
                        name={'contact_sms_opt_in'}
                        label={('sms')}
                        checked={data.contact_sms_opt_in === true || data.contact_sms_opt_in === 'true' || data.contact_sms_opt_in === 1 || data.contact_sms_opt_in === '1'}
                        onChange={(value) => onChange('contact_sms_opt_in', value === true ? 1 : 0)}
                        disabled={disabled}
                    />
                </div>
                <div className={'col-6 col-md-3'}>
                    <Checkbox
                        name={'contact_post_opt_in'}
                        label={('post')}
                        checked={data.contact_post_opt_in === true || data.contact_post_opt_in === 'true' || data.contact_post_opt_in === 1 || data.contact_post_opt_in === '1'}
                        onChange={(value) => onChange('contact_post_opt_in', value === true ? 1 : 0)}
                        disabled={disabled}
                    />
                </div>
            </div>
            <Text>Please note that you may withdraw your consent at any time by writing to Akoni Hub Limited, 86-90 Paul Street, London EC2A 4NE</Text>
            <SecondaryTitle>Anti-Money Laundering</SecondaryTitle>
            <Text>Under the current money laundering regulations, in common with other banks, we are required to verify the identity and address of the Authorised Officials, directors, partners and principal stakeholders/shareholders. We may use the services of electronic data registers, including, but not limited to, credit reference agencies to undertake such verification. We may also ask you to provide us with documents to confirm identity and addresses of relevant people.</Text>
            <Text>If, as part of your appointment of Akoni Hub as your trustees, you provide us with information about another person, you confirm that you have provided accurate information to your best knowledge. You are also confirming that you have told them about this application form, that they agree to the use of their personal data int his manner and that we may contact those officials and relevant people to verify their identity and addresses. Akoni reserves the right to refuse individuals to be Authorised Officials on any account operated by you. Information may be shared across the Akoni group in order to effectively administer your accounts.</Text>
            <FormInput
                required={true}
                name={'fees_payments'}
                detailedLabel={'Fees and payments'}
                value={data.fees_payments}
                type={'select'}
                options={fees_payments}
                onChange={(value) => onChange('fees_payments', value)}
                disabled={disabled}
                error={errors}
            />
            {data.fees_payments === 'Direct Debit' && (
                <>
                    <Text>Akoni will collect fees due via direct debit each quarter in arrears. The amount you will be billed is based on your overall cash on the platform. Please see below for applicable quarterly fees.</Text>
                    <Text className={"fw-bold"}>If you would like to better understand how Akoni fees are calculated and billed, please download our <a href="https://qa-cdn.akoni.io/illustrations/new_fees_illustration_2021-11-18.pdf">fees illustration</a>.</Text>
                    <Text className={"fw-bold"}>The total fee you will pay will be subject to the amounts deposited as detailed below:</Text>
                    <table className="table table-bordered">
                        <thead>
                        <tr>
                            <th className={'bg-transparent'}>Cash Level</th>
                            <th className={'bg-transparent'}>Half-yearly Fee</th>
                            <th className={'bg-transparent'}>Annual Fee</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                            <td className={'bg-transparent'}>£1,000 - £249,999</td>
                            <td className={'bg-transparent'}>0.125%</td>
                            <td className={'bg-transparent'}>0.25%</td>
                        </tr>
                        <tr>
                            <td className={'bg-transparent'}>£250,000 - £999,999</td>
                            <td className={'bg-transparent'}>0.11%</td>
                            <td className={'bg-transparent'}>0.22%</td>
                        </tr>
                        <tr>
                            <td className={'bg-transparent'}>£1,000,000 - £1,999,999</td>
                            <td className={'bg-transparent'}>0.1%</td>
                            <td className={'bg-transparent'}>0.2%</td>
                        </tr>
                        <tr>
                            <td className={'bg-transparent'}>£2,000,000 - £4,999,999</td>
                            <td className={'bg-transparent'}>0.09%</td>
                            <td className={'bg-transparent'}>0.18%</td>
                        </tr>
                        <tr>
                            <td className={'bg-transparent'}>£5,000,000 - No Maximum *</td>
                            <td className={'bg-transparent'}>0.075%</td>
                            <td className={'bg-transparent'}>0.15%</td>
                        </tr>
                        </tbody>
                    </table>
                    <Text>* If your cash savings are likely to exceed £20,000,000, please speak to our accounts team.</Text>
                </>
            )}
            {data.fees_payments === 'By Invoice' && (
                <>
                    <Text>You will be billed every 6 months in advance by invoice. The amount you will be billed is based on your overall cash on the platform. Please see below for applicable half-yearly fees.</Text>
                    <Text className={"fw-bold"}>If you would like to better understand how Akoni fees are calculated and billed, please download our <a href="https://qa-cdn.akoni.io/illustrations/new_fees_illustration_2021-11-18.pdf">fees illustration</a>.</Text>
                    <Text className={"fw-bold"}>The total fee you will pay will be subject to the amounts deposited as detailed below:</Text>
                    <table className="table table-bordered">
                        <thead>
                        <tr>
                            <th className={'bg-transparent'}>Cash Level</th>
                            <th className={'bg-transparent'}>Half-yearly Fee</th>
                            <th className={'bg-transparent'}>Annual Fee</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                            <td className={'bg-transparent'}>£1,000 - £249,999</td>
                            <td className={'bg-transparent'}>0.125%</td>
                            <td className={'bg-transparent'}>0.25%</td>
                        </tr>
                        <tr>
                            <td className={'bg-transparent'}>£250,000 - £999,999</td>
                            <td className={'bg-transparent'}>0.11%</td>
                            <td className={'bg-transparent'}>0.22%</td>
                        </tr>
                        <tr>
                            <td className={'bg-transparent'}>£1,000,000 - £1,999,999</td>
                            <td className={'bg-transparent'}>0.1%</td>
                            <td className={'bg-transparent'}>0.2%</td>
                        </tr>
                        <tr>
                            <td className={'bg-transparent'}>£2,000,000 - £4,999,999</td>
                            <td className={'bg-transparent'}>0.09%</td>
                            <td className={'bg-transparent'}>0.18%</td>
                        </tr>
                        <tr>
                            <td className={'bg-transparent'}>£5,000,000 - No Maximum *</td>
                            <td className={'bg-transparent'}>0.075%</td>
                            <td className={'bg-transparent'}>0.15%</td>
                        </tr>
                        </tbody>
                    </table>
                    <Text>* If your cash savings are likely to exceed £20,000,000, please speak to our accounts team.</Text>
                </>
            )}
            <SecondaryTitle>Other Fees</SecondaryTitle>
            <Text>Please ensure you Refer to the Fees table in the Terms and Conditions for full fee schedule and terms.</Text>
            <SecondaryTitle>Acknowledgment and confirmation</SecondaryTitle>
            <Text>All deposits with Akoni are subject to the Terms and Conditions which cover the opening and operation of all Akoni accounts and together with the platform literature and the Fees Table, form the basis of the contract between you and us.</Text>
            <SecondaryTitle>Certification and agreement</SecondaryTitle>
            <Text>For your own beneﬁt and protection, you should read the Terms and Conditions carefully before agreeing to them by returning this application form. If you do not understand any point please ask for further information. Copies of the Terms and Conditions are available on the link below.</Text>
            <div className={"form-input-container"}>
                <Checkbox
                    name={'agrees_tandc'}
                    label={('I/We apply to open the account(s) as indicated on this application form. I/We accept and agree to be bound by the <a href="https://qa-cdn.akoni.io/terms/Akoni+Hub+Limited+-+Terms+and+Conditions+20210322.pdf" target="_blank">Terms and Conditions</a> as varied from time to time, a copy of which we have had a chance to review. I/We agree to be bound by any additional conditions contained in this application form and confirm that the details given by us are true and correct and I/We warrant that they will remain true and correct until such time as you receive notice from us in writing to change the details, together with any necessary revised documentation required by you to make such change to the details.')}
                    checked={data.agrees_tandc === true || data.agrees_tandc === 'true' || data.agrees_tandc === 1 || data.agrees_tandc === '1'}
                    onChange={(value) => onChange('agrees_tandc', value === true ? 1 : 0)}
                    disabled={disabled}
                />
                <Error error={!!errors && !!errors.agrees_tandc ? errors.agrees_tandc : null} />
            </div>
            <div className={"form-input-container"}>
                <Checkbox
                    name={'agrees_tax_residency_change'}
                    label={('I/We undertake to advise Akoni by writing promptly of any change in the Account Holder’s tax residency and to provide Akoni with an updated declaration within 30 days of such a change in circumstances that makes any of the details as set out in this form inaccurate. I am/We are aware that in certain circumstances Akoni will be obliged to share this information with UK tax authorities, who may pass it on to other tax authorities.')}
                    checked={data.agrees_tax_residency_change === true || data.agrees_tax_residency_change === 'true' || data.agrees_tax_residency_change === 1 || data.agrees_tax_residency_change === '1'}
                    onChange={(value) => onChange('agrees_tax_residency_change', value === true ? 1 : 0)}
                    disabled={disabled}
                />
                <Error error={!!errors && !!errors.agrees_tax_residency_change ? errors.agrees_tax_residency_change : null} />
            </div>
            <div className={"form-input-container"}>
                <Checkbox
                    name={'agrees_akoni_authorization'}
                    label={('I/We, the signatories outlined below, request that Akoni opens and thereafter operates accounts in the Account Holder’s name as detailed above and may open such further panel account(s) as I/We may request per the Akoni Terms and Conditions. In connection with all accounts operated in the name of the Account Holder the signatories outlined below sign below to confirm that they are authorized as set out above and that all the information supplied in this form is accurate and approve and agree to the Akoni Terms and Conditions.')}
                    checked={data.agrees_akoni_authorization === true || data.agrees_akoni_authorization === 'true' || data.agrees_akoni_authorization === 1 || data.agrees_akoni_authorization === '1'}
                    onChange={(value) => onChange('agrees_akoni_authorization', value === true ? 1 : 0)}
                    disabled={disabled}
                />
                <Error error={!!errors && !!errors.agrees_akoni_authorization ? errors.agrees_akoni_authorization : null} />
            </div>
            <Text>The Account Holder hereby warrants that the authorised additional user has permission to access or control the Account Holder’s Akoni hub Account, and hereby gives consent for their data to be shared as necessary to such parties. The Authorised Additional User hereby warrants and represents that they are authorised to represent the Account Holder as set out above.</Text>
        </React.Fragment>
    );
}

export default Details;
